import { render, staticRenderFns } from "./VoucherSegmentClientModal.vue?vue&type=template&id=1966e3b7&scoped=true"
import script from "./VoucherSegmentClientModal.vue?vue&type=script&lang=js"
export * from "./VoucherSegmentClientModal.vue?vue&type=script&lang=js"
import style0 from "./VoucherSegmentClientModal.vue?vue&type=style&index=0&id=1966e3b7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1966e3b7",
  null
  
)

export default component.exports